import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import {
  ErrorDetails,
} from 'app/services/authentication/connection/interfaces/apiInterfaces';

export class ImportContractorEmployeeCommand extends IRequestCommand<
IImportContractorEmployeeResponse,
  ErrorDetails,
  FormData
  > {

  public override setParameters(formData: FormData) {
    this._commandType = CommandRequestType.POST;
    this._commandUrl = `contractorEmployees/${formData.get('contractor')}/import`;
    this._commandBody = formData;
  }
}

export interface IImportContractorEmployeeResponse extends ICommandResponse {
  successLines: number,
  errors: Array<IImportCSVError>,
  warnings: Array<IImportCSVError>
}

export interface IImportCSVError {
  warning: string,
  error: string,
  lineNumber: number,
  line: Object
}
